module.exports = __webpack_public_path__ + "img/lang-3.98444cc7.jpg";